export const DEVICE_TYPE_ANDROID = 'android'
export const DEVICE_TYPE_IOS = 'ios'
export const DEVICE_TYPE_MOBILE = 'mobile'
